import React from 'react';
import styled, { css } from 'styled-components';
const cssObjects = {
    h1: css `
        font-weight: ${({ theme }) => theme.typography.font.weight.bold};
        font-size: ${({ theme }) => theme.typography.h1.fontSize};
        margin: ${({ theme }) => theme.typography.h1.margin};
        padding: ${({ theme }) => theme.typography.h1.padding};
    `,
    h2: css `
        font-weight: ${({ theme }) => theme.typography.font.weight.bold};
        font-size: ${({ theme }) => theme.typography.h2.fontSize};
        margin: ${({ theme }) => theme.typography.h2.margin};
        padding: ${({ theme }) => theme.typography.h2.padding};
    `,
    h3: css `
        font-weight: ${({ theme }) => theme.typography.font.weight.bold};
        font-size: ${({ theme }) => theme.typography.h3.fontSize};
        margin: ${({ theme }) => theme.typography.h3.margin};
        padding: ${({ theme }) => theme.typography.h3.padding};
    `,
    h4: css `
        font-weight: ${({ theme }) => theme.typography.font.weight.bold};
        font-size: ${({ theme }) => theme.typography.h4.fontSize};
        margin: ${({ theme }) => theme.typography.h4.margin};
        padding: ${({ theme }) => theme.typography.h4.padding};
    `,
    h5: css `
        font-weight: ${({ theme }) => theme.typography.font.weight.bold};
        font-size: ${({ theme }) => theme.typography.h5.fontSize};
        margin: ${({ theme }) => theme.typography.h5.margin};
        padding: ${({ theme }) => theme.typography.h5.padding};
        text-transform: uppercase;
    `,
    h6: css `
        font-weight: ${({ theme }) => theme.typography.font.weight.bold};
        font-size: ${({ theme }) => theme.typography.h6.fontSize};
        margin: ${({ theme }) => theme.typography.h6.margin};
        padding: ${({ theme }) => theme.typography.h6.padding};
        text-transform: uppercase;
    `,
    jumbo: css `
        font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
        font-size: ${({ theme }) => theme.typography.textStyles.jumbo.fontSize};
    `,
    big: css `
        font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
        font-size: ${({ theme }) => theme.typography.textStyles.big.fontSize};
    `,
    normal: css `
        font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
        font-size: ${({ theme }) => theme.typography.textStyles.normal.fontSize};
    `,
    small: css `
        font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
        font-size: ${({ theme }) => theme.typography.textStyles.small.fontSize};
    `,
    micro: css `
        font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
        font-size: ${({ theme }) => theme.typography.textStyles.micro.fontSize};
    `,
    notification: css `
        font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
        font-size: ${({ theme }) => theme.typography.textStyles.notification.fontSize};
    `,
    quote: css `
        font-family: ${({ theme }) => theme.typography.font.family.serif};
        font-size: ${({ theme }) => theme.typography.textStyles.quote.fontSize};
    `,
    author: css `
        font-family: ${({ theme }) => theme.typography.font.family.serif};
        font-size: ${({ theme }) => theme.typography.textStyles.author.fontSize};
    `,
};
const boldIt = (Container) => {
    return ({ children }) => {
        return (React.createElement(Container, null,
            React.createElement("b", null, children)));
    };
};
// allows <textStyles.Jumbo>bla</textStyles.Jumbo>
// <textStyles.Jumbo.Bold>bla</textStyles.Jumbo.Bold>
// and ${textStyles.css} // for use in css blocks
const packStyle = (key) => {
    const BaseComponent = styled.span `
        ${cssObjects[key]}
    `;
    return Object.assign(BaseComponent, {
        css: cssObjects[key],
        Bold: boldIt(BaseComponent),
    });
};
// only holding css for headers
const H1 = { css: cssObjects.h1 };
const H2 = { css: cssObjects.h2 };
const H3 = { css: cssObjects.h3 };
const H4 = { css: cssObjects.h4 };
const H5 = { css: cssObjects.h5 };
const H6 = { css: cssObjects.h6 };
// hold component, css, and bold component for rest
const Jumbo = packStyle('jumbo');
const Big = packStyle('big');
const Normal = packStyle('normal');
const Small = packStyle('small');
const Micro = packStyle('micro');
const Notification = packStyle('notification');
const Quote = packStyle('quote');
const Author = packStyle('author');
const baseCodeStyles = (_) => css `
    font-family: ${({ theme }) => theme.typography.font.family.code};
    font-size: ${({ theme }) => theme.typography.textStyles.code.fontSize};
    background-color: ${({ theme, variant }) => {
    return variant === 'dark'
        ? theme.typography.textStyles.code.contrastBackgroundColor.toString()
        : 'transparent';
}};
    color: ${({ theme, variant }) => {
    return variant === 'dark'
        ? theme.typography.textStyles.code.contrastColor.toString()
        : 'auto';
}};
`;
const Code = styled.pre `
    ${baseCodeStyles}

    padding: ${({ theme }) => theme.typography.textStyles.code.padding.toString()};
`;
const InlineCode = styled.code `
    ${baseCodeStyles}

    display: inline-block;
    padding: 0 ${({ theme }) => theme.spacing.xxs.toString()};
    margin: 0 ${({ theme }) => theme.spacing.xxs.toString()};
`;
export const textStyles = {
    H1,
    H2,
    H3,
    H4,
    H5,
    H6,
    Jumbo,
    Big,
    Normal,
    Small,
    Micro,
    Notification,
    Quote,
    Author,
    Code,
    InlineCode,
};
//# sourceMappingURL=textStyles.js.map